export const getCookieValue = (a) => {
  const b = document.cookie.match("(^|[^;]+)\\s*" + a + "\\s*=\\s*([^;]+)")
  return b ? b.pop() : ""
}

/**
 * Send a gtag event to the window
 *
 * @param {Object} eventObj
 */
export const gtagEvent = (eventObj) => {
  try {
    window.dataLayer = window?.dataLayer || []
    window.dataLayer.push(eventObj)
  } catch (err) {
    console.error(`gtag event failed: ${err}`)
  }
}
